import { AgmCoreModule } from 'ng-agm-core-lib';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorsModule } from './errors/errors.module';
import { PublicModule } from './public/public.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { GuardsModule } from './guards/guards.module';
import { ServicesModule } from './services/services.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InterceptorsModule } from './interceptors/interceptors.module';
import { ToastModule } from 'primeng/toast';
import { UnsavedChangesModalModule } from './main/shared/unsaved-changes-modal/unsaved-changes-modal.module';
import { PasswordResetModule } from './public/password-reset/password-reset.module';
import { OfflineScreenModule } from './main/offline-screen/offline-screen.module';
import { TermsOverlayModule } from './main/terms-overlay/terms-overlay.module';
import { RedirectModule } from './main/shared/redirect/redirect.module';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { InstanceSelectorModule } from './instance-selector/instance-selector.module';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { QuoteApprovalModule } from './non-login/quote-approval/quote-approval.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

@NgModule({
  declarations: [
    AppComponent,
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAGuWYDsGeVymk3aPRtgTP3hl_OuwfcFKg',
      libraries: ['places']
    }),
    ErrorsModule,
    PublicModule,
    GuardsModule,
    ServicesModule,
    InterceptorsModule,
    BsDropdownModule,
    TooltipModule,
    ButtonsModule,
    AccordionModule,
    PopoverModule,
    ToastModule,
    UnsavedChangesModalModule,
    PasswordResetModule,
    OfflineScreenModule,
    TermsOverlayModule,
    RedirectModule,
    MonacoEditorModule.forRoot(),
    InstanceSelectorModule,
    QuoteApprovalModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false || 'none'
        }
      }
    }),
  ]
})
export class AppModule {
}
